import { useField } from 'formik'

import { useActions } from './useActions'
import { useValidate } from './useValidate'
import type { Time, TimePickerProps } from '../typings'
import { useListState } from './useListState'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

export function useTimePicker(props: TimePickerProps) {
  const {
    name,
    tidalAdditionalStyling,
    helperText,
    placeholder: holder,
  } = props

  const validate = useValidate(props)
  const [{ value }, { error, touched }] = useField<Time>({ name, validate })

  const tidalThemeActive = useTidalThemeActive()
  const listState = useListState(value)
  const actions = useActions({ name, value })

  function formattedErrorMessage() {
    if (error == 'Invalid date format' || error == 'Invalid format') {
      return 'Invalid time format'
    }
    return error
  }

  const hasError = error !== undefined && touched
  const message = hasError ? formattedErrorMessage() : helperText
  const placeholder = holder || 'hh:mm am/pm'

  return {
    value,
    ...actions,
    ...listState,
    error: hasError,
    helperText: message,
    placeholder,
    tidalAdditionalStyling,
    tidalThemeActive,
  }
}
